import fi from './fi.json';
import en from './en.json';
import sv from './sv.json';
import et from './et.json';

const translations = {
    fi: {
        translation: fi,
    },
    en: {
        translation: en,
    },
    sv: {
        translation: sv,
    },
    et: {
        translation: et,
    },
};

export default translations;
